<template>
  <div class="panel-body">
    <v-dialog persistent v-model="dialog" max-width="1000px">
      <card
        :card="(this.selected != null && this.selected.length > 0) ? this.selected[0] : null"
        :key="cardKey"
        @close-card="cardClosed"
        @save-card="cardSaved"
      ></card>
    </v-dialog>
    <template>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Filter</v-expansion-panel-header>
          <v-expansion-panel-content>
          <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search all"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-divider vertical class="mx-4"></v-divider>
            <v-flex xs12 sm6 sm4>
              <v-layout justify-space-around>
                <v-radio-group v-model="activeRadios" :mandatory="true" @change="staticFilter">
                  <span>State</span>
                  <v-radio label="All" value="all"></v-radio>
                  <v-radio label="Active" value="active"></v-radio>
                  <v-radio label="Inactive" value="inactive"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="priorityRadios" :mandatory="true" @change="staticFilter">
                  <span>Priority</span>
                  <v-radio label="All" value="all"></v-radio>
                  <v-radio label="Set" value="set"></v-radio>
                  <v-radio label="Not Set" value="not-set"></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="startingRadios"
                  :disabled="!canFilterStartingIn"
                  :mandatory="true"
                  @change="staticFilter"
                >
                  <span>Starting in...</span>
                  <v-radio label="All" value="all"></v-radio>
                  <v-radio label="24 Hours" value="24h"></v-radio>
                  <v-radio label="48 Hours" value="48h"></v-radio>
                  <v-radio label="1 Week" value="1w"></v-radio>
                  <v-radio label="2 Weeks" value="2w"></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="endingRadios"
                  :disabled="!canFilterEndingIn"
                  :mandatory="true"
                  @change="staticFilter"
                >
                  <span>Ending in...</span>
                  <v-radio label="All" value="all"></v-radio>
                  <v-radio label="24 Hours" value="24h"></v-radio>
                  <v-radio label="48 Hours" value="48h"></v-radio>
                  <v-radio label="1 Week" value="1w"></v-radio>
                  <v-radio label="2 Weeks" value="2w"></v-radio>
                </v-radio-group>
              </v-layout>
            <v-btn>reset</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
         </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
        <v-container>
          <v-layout>
            <v-flex xs12 sm6 md4>
              <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn> -->
              <v-btn @click="openCard" color="primary" dark class="mb-2">New Card</v-btn>
            </v-flex>
          </v-layout>
        </v-container>

      <v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredCards"
          :search="search"
          :loading="loadingCards"
          item-key="id"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
        >
          <template slot="item" slot-scope="props">
            <tr>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.type }}</td>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.subType }}</td>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.priority }}</td>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.title }}</td>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.description }}</td>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.startDate }}</td>
              <td class="text-xs-left" @click="selectCard(props.item)">{{ props.item.endDate }}</td>
              <td class="justify-center layout px-4">
                <v-icon small @click="deleteItem(props.item)">visibility</v-icon>
              </td>
            </tr>
          </template>
          <template slot="no-data"></template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>
<script>
import card from '@/components/Card.vue'
import { consoleInfo } from 'vuetify/src/util/console'
let rh = require('@/components/APIs/RequestHandler')

export default {
  data: () => ({
    headers: [
      { text: 'Type', value: 'type' },
      { text: 'Sub Type', value: 'subType' },
      { text: 'Priority', value: 'priority' },
      { text: 'Title', value: 'title' },
      { text: 'Description', value: 'description' },
      {
        text: 'Start',
        value: 'startDate',
        filter: value => {
          return true
        }
      },
      {
        text: 'End',
        value: 'endDate',
        filter: value => {
          return true
        }
      }
    ],
    cards: [],
    filteredCards: [],
    activeRadios: 'all',
    startingRadios: 'all',
    endingRadios: 'all',
    priorityRadios: 'all',
    dialog: false,
    search: '',
    rppItems: [
      10,
      20,
      40,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    errors: [],
    selected: [],
    loadingCards: false,
    cardKey: 0
  }),

  created () {
    this.initialize()
  },
  components: {
    card
  },
  computed: {
    getCardToEdit () {
      if (this.selected && this.selected.length > 0) {
        return this.selected[0]
      } else {
        return null
      }
    },
    canFilterStartingIn () {
      return this.activeRadios !== 'active'
    },
    canFilterEndingIn () {
      return this.activeRadios !== 'inactive'
    }
  },
  methods: {
    async initialize () {
      const endpoint = `${process.env.VUE_APP_QUBER_SERVICE_CARDS}/cards`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (getResponse === undefined || getResponse.data === '') {
        this.cards = []
      } else {
        this.cards = getResponse.data
      }

      // Iterate over cards & set type to recommendation if amount != null
      this.cards.forEach(card => {
        if (card.amount != null && card.infor) {
          card.type = 'recommendation'
        }
      })

      this.filteredCards = this.cards
    },
    deleteItem (item) {
      const index = this.cards.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.cards.splice(index, 1)
    },
    staticFilter () {
      this.filteredCards = this.cards

      if (this.priorityRadios !== 'all') {
        this.filteredCards = this.filteredCards.filter(i => {
          return (
            (this.priorityRadios === 'set' && i.priority != null) ||
            (this.priorityRadios === 'not-set' && i.priority == null)
          )
        })
      }
      var today = new Date().getTime()
      if (this.activeRadios !== 'all') {
        this.filteredCards = this.filteredCards.filter(i => {
          var result = true
          var startDate = new Date(i.startDate).getTime()
          var endDate = i.endDate ? new Date(i.endDate).getTime() : null
          return (
            (this.activeRadios === 'active' &&
              today >= startDate &&
              (endDate === null || today < endDate)) ||
            (this.activeRadios === 'inactive' &&
              (today < startDate || (endDate !== null && today >= endDate)))
          )
        })
      }
      if (this.startingRadios !== 'all') {
        this.filteredCards = this.filteredCards.filter(i => {
          var compareDate = new Date()
          var startDate = new Date(i.startDate).getTime()
          if (this.startingRadios === '24h') {
            compareDate.setHours(compareDate.getHours() + 24)
          } else if (this.startingRadios === '48h') {
            compareDate.setHours(compareDate.getHours() + 48)
          } else if (this.startingRadios === '1w') {
            compareDate.setHours(compareDate.getHours() + 7 * 24)
          } else if (this.startingRadios === '2w') {
            compareDate.setHours(compareDate.getHours() + 14 * 24)
          }
          return startDate > today && startDate <= compareDate.getTime()
        })
      }
      if (this.endingRadios !== 'all') {
        this.filteredCards = this.filteredCards.filter(i => {
          var compareDate = new Date()
          if (i.endDate === null) return false
          var endDate = new Date(i.endDate).getTime()
          if (this.endingRadios === '24h') {
            compareDate.setHours(compareDate.getHours() + 24)
          } else if (this.endingRadios === '48h') {
            compareDate.setHours(compareDate.getHours() + 48)
          } else if (this.endingRadios === '1w') {
            compareDate.setHours(compareDate.getHours() + 7 * 24)
          } else if (this.endingRadios === '2w') {
            compareDate.setHours(compareDate.getHours() + 14 * 24)
          }
          return endDate > today && endDate <= compareDate.getTime()
        })
      }
    },
    async selectCard (a) {
      this.selected = [a]
      this.dialog = true

      this.cardKey++
    },
    cardSaved (card) {
      this.dialog = false
      // replace the old card item with the newly saved one
      var savedIndex = this.cards.indexOf(this.selected[0])
      var savedCard = JSON.parse(card)
      this.cards.splice(savedIndex, 1, savedCard)
      this.selected = []
    },
    cardClosed () {
      this.dialog = false
      this.selected[0] = null
      this.selected = []
    },
    getFilenameFromURL (url) {
      if (!url) return ''
      return url.split(/[/]+/).pop()
    },
    isWebSubType (subType) {
      return subType != null && subType.toUpperCase() === 'WEB'
    },
    startsWithHttp (url) {
      if (!url) return ''
      return url != null && /^http/i.test(url)
    },
    isMailTo (url) {
      if (!url) return ''
      return url != null && /^mailto/i.test(url)
    },
    filteredPriorities () {},
    openCard () {
      this.dialog = true
      this.cardKey++
    }
  }
}
</script>
<style>
/* a.disabled {
  pointer-events: none;
} */
</style>
